<template>
  <div>
    <div>
      <b-card title="Duplicate Transactions">
        <b-row class="mb-1">
          <!-- search input -->
          <b-col>
            <section>
              <b-button
                v-b-modal.modal-filter-orders
                variant="outline-primary"
                class="d-flex"
              >
                <feather-icon icon="FilterIcon" />Filter
              </b-button>
            </section>
          </b-col>
          <b-col>
            <b-form-group
              v-if="dataFiltered == true"
              class="d-flex justify-content-center"
            >
              <!-- search input -->
              <div>
                <b-form-input
                  v-model="searchTerm"
                  type="search"
                  placeholder="search"
                />
              </div>
            </b-form-group>
          </b-col>

          <b-col class="d-flex justify-content-end">
            <section v-if="dataFiltered === true">
              <xlsx-workbook>
                <xlsx-sheet
                  v-for="sheet in sheets"
                  :key="sheet.name"
                  :collection="sheet.data"
                  :sheet-name="sheet.name"
                />
                <xlsx-download>
                  <b-button variant="primary" class="d-flex">
                    <feather-icon icon="DownloadCloudIcon" /> Export
                  </b-button>
                </xlsx-download>
              </xlsx-workbook>
            </section>
          </b-col>
        </b-row>
        <!-- table -->
        <vue-good-table
          :columns="columns"
          :rows="reconciliations"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['5', '10', '15', '30', '50']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

        <b-row>
          <b-col>
            <b-modal
              id="modal-filter-orders"
              title="Filter Reconcilation"
              ok-title="Search"
              cancel-variant="outline-secondary"
              size="lg"
              @ok="filterOrders"
            >
              <b-form>
                <b-row>
                  <b-col cols="4">
                    <b-form-group
                      label="Payment option"
                      label-for="payment-option"
                    >
                      <b-form-select
                        id="merchantId"
                        v-model="filterFopId"
                        :options="paymentOptions"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <h5>Order Date Range</h5>
                      <flat-pickr
                        v-model="orderDateRange"
                        class="form-control"
                        :config="{ mode: 'range', maxDate: 'today' }"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <h5>Paid Date Range</h5>
                      <flat-pickr
                        v-model="trxnDateRange"
                        class="form-control"
                        :config="{ mode: 'range', maxDate: 'today' }"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-modal>
          </b-col>
        </b-row>

        <!-- loadings -->
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      selectedOrderRefund: "",
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      orderDateRange: "",
      trxnDateRange: "",
      VendorTxnRefNumber: "",
      orderStartDate: "",
      trxnStartDate: "",
      orderEndDate: "",
      trxnEndDate: "",
      orderFirstName: "",
      orderLastName: "",
      orderEmail: "",
      orderPhone: "",
      orderAmount: "",
      orderCurrency: "",
      orderCity: "",
      orderCountry: "",
      orderChannel: "",
      selectedOrder: "",
      filterOrderId: "",
      filterFopId: 0,
      filterFirstName: "",
      filterLastName: "",
      filtertrnxDate: "",
      columns: [
        {
          label: "Merchant Name",
          field: "merchantName",
        },
        {
          label: "Custom Order Code",
          field: "merchantOrderCode",
        },
        {
          label: "Order Code",
          field: "orderId",
        },

        {
          label: "Order Date",
          field: "orderDate",
        },

        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Paid Payment Option",
          field: "paymentOptionDescription",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Payment RefNumber",
          field: "partnerReferenceNumber",
        },
        {
          label: "Paid Date",
          field: "paidDateString",
        },
        {
          label: "Expiry Date",
          field: "expiryDate",
        },
      ],
      paymentOptions: [{ value: 0, text: "--select Payment Option--" }],

      searchTerm: "",
      editabelData: {},
      orderHistory: [],
      orderRefundHistory: [],

      referenceState: null,
      selectedOrderCode: "",
      titleApprove: "",
      amount: 0,
      reconciliations: [],
      summary: [],
      sheets: [
        { name: "Detail Transactions", data: [] },
        { name: "Summary", data: [] },
      ],
      searchTerm: "",
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchallPaymentOptions();
  },
  beforeCreate() {
    this.$http.get("/account-setting/data").then((res) => {
      this.options = res.data;
    });
  },
  methods: {
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterOrders() {
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      const url = `/Reconciliation/api/V1.0/Reconciliation/GetDuplicateReconciliation?paymentOptionId=${this.filterFopId}&FromPaidDate=${this.trxnStartDate}&ToPaidDate=${this.trxnEndDate}  &FromOrderDate=${this.orderStartDate}&ToOrderDate=${this.orderEndDate}`;
      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.reconciliations = res.reconciliation;
          this.summary = res.summary;
          this.sheets[0].data = [];
          res.reconciliation.map((f) => {
            this.sheets[0].data.push({
              Merchant_Name: f.merchantName,
              Custom_Order_Code: f.merchantOrderCode,
              Order_Code: f.orderId,
              Order_Date: f.orderDate,
              First_Name: f.firstName,
              Last_Name: f.lastName,
              Paid_Payment_Option: f.paymentOptionDescription,
              Amount: f.amount,
              Payment_RefNumber: f.partnerReferenceNumber,
              Paid_Date: f.paidDateString,
              Expiry_Date: f.expiryDate,
            });
          });
          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.reconciliations = [];
          this.summary = [];

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
